import Axios from 'axios';
import Moment from 'moment';
import BrowserStore from 'store';
import { getCookie, removeCookie, setCookie } from 'tiny-cookie';
import { parseResponse, handleError } from '@/_helpers/utils.js';

import UserApi from '@/api/user.js';
import Store, { resetState } from '@/store';
import AccessTokenApi from '@/api/access_token.js';
import { ADMIN_ROLES } from '@/_helpers/constants';

const Security = {
  get accessToken() {
    const accessTokenObject = getCookie('access_token')
      ? JSON.parse(getCookie('access_token'))
      : null;
    const accessToken = accessTokenObject ? accessTokenObject?.token : {};

    return BrowserStore.get('access_token') || accessToken || {};
  },

  set accessToken(val) {
    BrowserStore.set('access_token', val);
  },

  get admin_token() {
    const localStorage_admin_token = BrowserStore.get('admin_token');
    const cookie_admin_token = getCookie('admin_token');

    return localStorage_admin_token || cookie_admin_token || {};
  },

  set admin_token(val) {
    BrowserStore.set('admin_token', val);
    setCookie('admin_token', val, { domain: `.${Security.domain()}` });
  },

  get user() {
    return Security.accessToken.user;
  },

  set user(val) {
    Security.accessToken.user = val;

    const newAccessToken = Object.assign({}, Security.accessToken, {
      user: val
    });

    Security.accessToken = newAccessToken;
  },

  get admin_user() {
    return Security.admin_token.user;
  },

  set admin_user(val) {
    Security.admin_token.user = val;

    const newAccessToken = Object.assign({}, Security.admin_token, {
      user: val
    });

    Security.admin_token = newAccessToken;
  },

  hasRole(needed, roles) {
    return roles.some(({ role }) => role === needed);
  },

  domain() {
    if (!window.location || !window.location.host) {
      return '';
    }

    if (window.location.hostname === '127.0.0.1') {
      return '127.0.0.1';
    }

    const host = window.location.hostname;
    const hostArray = host.split('.');
    return `.${hostArray.slice(hostArray.length - 2).join('.')}`;
  },

  authFromRegistration(email, token) {
    return new Promise((resolve, reject) => {
      Security.applyAccessToken(token);
      UserApi.fetchOneUser(email)
        .then(({ data, meta }) => {
          if (
            data &&
            data.roles &&
            data.roles.length &&
            ADMIN_ROLES.some(role => this.hasRole(role, data.roles))
          ) {
            let user = Object.assign(token.user, { roles: data.roles });
            Security.applyAdminToken(Object.assign(token, { user }));
          }

          Store.commit('user/userInfoRequestSuccess', { data, meta });
          Store.dispatch('activeProcess/determineCompanyActiveProcess');

          const user_locale = data && data.language ? data.language.code : null;
          const current_locale = Store.getters['locale/current'];
          Security.user = data;

          if (user_locale && user_locale !== current_locale) {
            Store.dispatch('locale/change', user_locale);
          }

          if (meta && meta.redirect_domain) {
            Security.setReloginAccessToken();
            Security.set_cookie_admin_token();
            window.location.href = `${meta.redirect_domain}/responses`;
            return Object.assign({}, data, { redirect_domain: meta.redirect_domain });
          }
          resolve(Object.assign({}, data, { redirect_domain: meta.redirect_domain }));

          // return Object.assign({}, data, {redirect_domain: meta.redirect_domain});
        })
        .catch(e => {
          return reject(e);
        });
    });
  },

  login(user, password, captcha_token) {
    if (!user || !user.email || !password) {
      throw new Error('Empty email or password');
    }

    return AccessTokenApi.storeOne({ email: user.email, password, captcha_token }).then(
      accessToken => {
        return Security.afterLoginActions(accessToken);

        // Security.applyAccessToken(accessToken);

        // return accessToken;
      }
    );
    // .then(accessToken => {
    //   const user = UserApi.fetchOneUser(accessToken.user.email);
    //
    //   return { user: user, accessToken: accessToken };
    // })
    // .then(userInfo => {
    //   const data = userInfo.user.data;
    //   const meta = userInfo.user.meta;
    //
    //   if (
    //     data &&
    //     data.roles &&
    //     data.roles.length &&
    //     ADMIN_ROLES.some(role => this.hasRole(role, data.roles))
    //   ) {
    //     let user = Object.assign(userInfo.accessToken.user, { roles: data.roles });
    //
    //     Security.applyAdminToken(Object.assign(userInfo.accessToken, { user }));
    //   }
    //
    //   Store.commit('user/userInfoRequestSuccess', { data, meta });
    //   Store.dispatch('activeProcess/determineCompanyActiveProcess');
    //
    //   const user_locale = data && data.language ? data.language.code : null;
    //   const current_locale = Store.getters['locale/current'];
    //
    //   Security.user = data;
    //
    //   if (user_locale && user_locale !== current_locale) {
    //     Store.dispatch('locale/change', user_locale);
    //   }
    //
    //   if (meta && meta.redirect_domain) {
    //     Security.setReloginAccessToken();
    //     Security.set_cookie_admin_token();
    //     window.location.href = `${meta.redirect_domain}/responses`;
    //     return Object.assign({}, data, { redirect_domain: meta.redirect_domain });
    //   }
    //
    //   return Object.assign({}, data, { redirect_domain: meta.redirect_domain });
    // })
    // .catch(e => {
    //   return Promise.reject(e);
    // });
  },

  async afterLoginActions(accessTokenObject) {
    Security.applyAccessToken(accessTokenObject);

    const userInfo = await UserApi.fetchOneUser(accessTokenObject.user.email);
    const data = userInfo.data;
    const meta = userInfo.meta;

    if (
      data &&
      data.roles &&
      data.roles.length &&
      ADMIN_ROLES.some(role => this.hasRole(role, data.roles))
    ) {
      let user = Object.assign(accessTokenObject.user, { roles: data.roles });

      Security.applyAdminToken(Object.assign(accessTokenObject, { user }));
    }

    Store.commit('user/userInfoRequestSuccess', { data, meta });
    Store.dispatch('activeProcess/determineCompanyActiveProcess');

    const user_locale = data && data.language ? data.language.code : null;
    const current_locale = Store.getters['locale/current'];

    Security.user = data;

    if (user_locale && user_locale !== current_locale) {
      Store.dispatch('locale/change', user_locale);
    }

    if (meta && meta.redirect_domain) {
      Security.setReloginAccessToken();
      Security.set_cookie_admin_token();
      window.location.href = `${meta.redirect_domain}/responses`;
      // return Object.assign({}, data, { redirect_domain: meta.redirect_domain });
    }

    return Object.assign({}, data, { redirect_domain: meta.redirect_domain });
  },

  logout(to, from, next) {
    const token = Security.accessToken.token;

    if (token) {
      AccessTokenApi.removeOne({ token });
    }

    Security.removeAccessToken();
    Security.removeAdminToken();

    resetState();
    // window.location.reload();
    next('/login');
  },

  authorize(to, from, next) {
    const token = to.params.token;

    if (!token) {
      return next();
    }

    AccessTokenApi.fetchOneAuthorization(token)
      .then(accessToken => {
        Security.applyAccessToken(accessToken);

        return accessToken;
      })
      .then(accessToken => {
        Security.applyAccessToken(accessToken);
        next('/');
      })
      .catch(() => next('/login'));
  },

  authUser({ commit }, user) {
    commit('auth');
    Security.applyAdminToken();

    return Axios.post('/1.0/user-access-tokens', { users: [{ email: user.email }] })
      .then(response => {
        const data = parseResponse(response).data[0];
        const meta = parseResponse(response).meta;
        Security.applyAccessToken(data);

        if (meta && meta.redirect_domain) {
          window.location.href = `${meta.redirect_domain}/responses`;
          return;
        }
      })
      .then(commit('authSuccess'))
      .catch(err => {
        const error = handleError(err);
        commit('authFailure', error);
      });
  },

  notRequireAuth(to, from, next) {
    Store.commit('services/setRequireAuthFinished', true);
    next();
  },

  // TODO: Commented onboarding (while economic crysis)
  // checkOnboarding() {
  //   const user = Security.user || Store.state.user.data;
  //
  //   if (user && user.company && user.company.is_onboarding_enabled) {
  //     Security.loadOnboarding();
  //   }
  // },

  // loadOnboarding(callback) {
  //   load_script(
  //     'https://cdn.experrto.io/clients/74ca7056b0261f58c8229f880554e2b276535c4a/script.js',
  //     'experrto',
  //     () => {
  //       if (callback) {
  //         callback();
  //       }
  //     },
  //     'async'
  //   );
  // },

  requireAuth(to, from, next) {
    console.log('requireAuth');

    if (to.name === 'relogin') {
      if (!to.query.user_email) {
        Security.applyReloginAccessToken();
        window.location.href = `/responses`;
        return;
      }

      Security.set_admin_token();
      Security.set_cookie_admin_token();
      Axios.post('/1.0/user-access-tokens', { users: [{ email: to.query.user_email }] })
        .then(response => {
          const data = parseResponse(response).data[0];
          const meta = parseResponse(response).meta;
          Security.applyAccessToken(data);
          let path = '/responses';

          if (to.query.to) {
            if (to.query.to.indexOf('relogin') === -1) {
              path = to.query.to;
            }
          }

          if (meta && meta.redirect_domain) {
            Security.setReloginAccessToken();
            window.location.href = `${meta.redirect_domain}${path}`;
            return;
          }

          Store.commit('services/setRequireAuthFinished', true);
          next({ path: path });
        })
        .catch(() => {
          Store.commit('services/setRequireAuthFinished', true);
          next({ path: '/login' });
        });
    } else {
      Security.checkAccessToken();
      Security.applyReloginAccessToken();

      const token = Security.accessToken.token;
      const newAuthorizationHeader = Security.authorizationHeader(token);
      const storeUser = Store.state.user.data;
      const tokenUser = Security.accessToken.user;

      // this check is for situation with few tabs with different accounts in one browser
      if (
        token &&
        Axios.defaults.headers.common['Authorization'] &&
        newAuthorizationHeader !== Axios.defaults.headers.common['Authorization']
      ) {
        if (storeUser && tokenUser && storeUser.email === tokenUser.email) {
          // this is the same user just new token, update authorization header only
          Axios.defaults.headers.common['Authorization'] = newAuthorizationHeader;
        } else {
          // this is another user token, move to login page
          Axios.defaults.headers.common['Authorization'] = null;
          Store.commit('services/setRequireAuthFinished', true);

          return next({
            path: '/login',
            query: { redirect: to.fullPath }
          });
        }
      }
      // --
      if (token && storeUser) {
        // TODO: Commented onboarding
        // Security.checkOnboarding();
        Store.commit('services/setRequireAuthFinished', true);

        return next();
      }

      let user;

      const cookie_admin_token = getCookie('admin_token')
        ? JSON.parse(getCookie('admin_token'))
        : null;

      if (cookie_admin_token) {
        Security.admin_token = cookie_admin_token;
        Security.remove_admin_token_cookies();
      }

      if (to.path.indexOf('/admin/') === 0) {
        Security.set_admin_token();
        user = Security.admin_user;
      } else {
        user = Security.user;
      }

      const email = user ? user.email : null;

      if (!email) {
        Store.commit('services/setRequireAuthFinished', true);
        return next({
          path: '/login',
          query: { redirect: to.fullPath }
        });
      }

      UserApi.fetchOneUser(email)
        .then(({ data, meta }) => {
          // set common specprocess in modules/user
          if (data.company && data.company.meta !== undefined) {
            if (data.company.meta.active_process !== null) {
              Store.commit(
                'process/SET_COMPANY_COMMON_SPECIAL_PROCESS',
                data.company.meta.active_process
              );
            }
          }

          Store.commit('user/userInfoRequestSuccess', { data, meta });

          if (
            data &&
            data.roles &&
            data.roles.length &&
            ADMIN_ROLES.some(role => Security.hasRole(role, data.roles))
          ) {
            let user = Object.assign(Security.admin_token.user, { roles: data.roles });
            Security.applyAdminToken(Object.assign(Security.admin_token, { user }));
          }

          if (meta && meta.redirect_domain && window.location.pathname !== '/relogin') {
            console.log('location.hrefs!');
            Security.setReloginAccessToken();
            Security.set_cookie_admin_token();

            window.location.href = `${meta.redirect_domain}${
              !window.location.pathname !== '/login' &&
              !window.location.pathname !== '/relogin' &&
              window.location.pathname.indexOf('/registration') !== 0
                ? window.location.pathname
                : '/responses'
            }`;

            return { is_redirect: true };
          }

          Store.dispatch('activeProcess/determineCompanyActiveProcess');
          const user_locale = data && data.language ? data.language.code : null;
          const current_locale = Store.getters['locale/current'];
          Security.user = data;

          if (user_locale && user_locale !== current_locale) {
            Store.dispatch('locale/change', user_locale);
          }
        })
        .then(data => {
          if (data && data.is_redirect) {
            return;
          }
          // TODO: Commented onboarding
          // Security.checkOnboarding();
          Store.commit('services/setRequireAuthFinished', true);
          next();
        })
        .catch(() => {
          Store.commit('services/setRequireAuthFinished', true);
          next('/login');
        });
    }
  },

  auth_check(to, from, next) {
    if (window.localStorage.getItem('access_token') !== null) {
      return next({
        name: `online-inner`,
        params: { token: to.params.token }
      });
    } else {
      return next();
    }
  },

  auth_online(to, from, next) {
    if (window.localStorage.getItem('access_token') !== null) {
      return next({
        name: `online-interview-inner`,
        params: { token: to.params.token }
      });
    } else {
      return next();
    }
  },

  setReloginAccessToken() {
    setCookie('relogin_access_token', JSON.stringify(Security.accessToken), {
      domain: `${Security.domain()}`
    });
  },

  applyReloginAccessToken() {
    const cookie_access_token = getCookie('relogin_access_token');
    const decoded_cookie_access_token = JSON.parse(cookie_access_token);

    if (decoded_cookie_access_token) {
      Security.accessToken = decoded_cookie_access_token;
      Axios.defaults.headers.common['Authorization'] = Security.authorizationHeader(
        Security.accessToken.token
      );
    }

    const host = window.location.hostname;
    const hostArray = host.split('.');
    const subdomain = hostArray.slice(hostArray.length - (hostArray.length > 2 ? 3 : 2)).join('.');

    removeCookie('relogin_access_token', { domain: `.${subdomain}` });
    removeCookie('relogin_access_token', {
      domain: `.${hostArray.slice(hostArray.length - 2).join('.')}`
    });
    removeCookie('relogin_access_token', {
      domain: `.${hostArray.slice(hostArray.length - 3).join('.')}`
    });
  },

  checkAccessToken() {
    // const accessTokenFromCookie = document.cookie
    //   .split(';')
    //   .filter(item => item.trim().startsWith('access_token='));
    //
    // console.log(document.cookie);
    // console.log(accessTokenFromCookie);
    //
    // if (accessTokenFromCookie.length) {
    //   console.log('The cookie "access_token" exist ' + accessTokenFromCookie);
    // }

    const token = Security.accessToken;

    if (token) {
      try {
        Security.applyAccessToken(token);
      } catch (err) {
        Security.removeAccessToken(token);
      }
    }
  },

  remove_admin_token_cookies() {
    const host = window.location.hostname;
    const hostArray = host.split('.');
    const subdomain = hostArray.slice(hostArray.length - (hostArray.length > 2 ? 3 : 2)).join('.');

    removeCookie('admin_token', { domain: `.${subdomain}` });
    removeCookie('admin_token', { domain: `.${hostArray.slice(hostArray.length - 2).join('.')}` });
    removeCookie('admin_token', { domain: `.${hostArray.slice(hostArray.length - 3).join('.')}` });
  },

  set_admin_token() {
    const admin_token = Security.admin_token ? Security.admin_token.token : null;

    if (admin_token) {
      Axios.defaults.headers.common['Authorization'] = Security.authorizationHeader(admin_token);
    }
  },

  set_cookie_admin_token() {
    if (Security.admin_token && Security.admin_token.token) {
      setCookie('admin_token', JSON.stringify(Security.admin_token), {
        domain: `${Security.domain()}`
      });
    }
  },

  requireAdminRights(to, from, next) {
    Security.requireAuth(to, from, params => {
      if (params) {
        return next(params);
      }

      const isAdmin = Store.getters['user/isAdmin'];

      if (isAdmin) {
        return next();
      }

      return next('/restricted');
    });
  },

  requireCompanyAdminRights(to, from, next) {
    Security.requireAuth(to, from, params => {
      if (params) {
        return next(params);
      }

      const isAdmin = Store.getters['user/isCompanyAdmin'];

      if (isAdmin) {
        return next();
      }

      return next('/restricted');
    });
  },

  applyAccessToken(accessToken) {
    const now = Moment();
    const expiredAt = accessToken && accessToken.expired_at ? Moment(accessToken.expired_at) : null;
    const token = accessToken ? accessToken.token : null;

    if (!token) {
      return new Error('Empty token');
    }

    if (!expiredAt) {
      throw new Error('Invalid token');
    } else if (now > expiredAt) {
      throw new Error(`Token expired ${expiredAt.fromNow()}`);
    }

    BrowserStore.set('access_token', accessToken);
    Axios.defaults.headers.common['Authorization'] = Security.authorizationHeader(token);
  },

  applyAdminToken(val) {
    let accessToken = val || Security.accessToken;
    const now = Moment();
    const expiredAt = accessToken && accessToken.expired_at ? Moment(accessToken.expired_at) : null;
    const token = accessToken ? accessToken.token : null;

    if (!token) {
      return new Error('Empty token');
    }

    if (!expiredAt) {
      throw new Error('Invalid token');
    } else if (now > expiredAt) {
      throw new Error(`Token expired ${expiredAt.fromNow()}`);
    }

    Security.admin_token = accessToken;
    Axios.defaults.headers.common['Authorization'] = Security.authorizationHeader(token);
  },

  removeAccessToken() {
    // 1. удаление accessToken из localStorage
    BrowserStore.remove('access_token');
  },

  removeAdminToken() {
    BrowserStore.remove('admin_token');
    Security.remove_admin_token_cookies();
  },

  // format authorization header string
  authorizationHeader(token) {
    return `Bearer ${token}`;
  }
};

export default Security;
